import { render } from "./PartnerManage.vue?vue&type=template&id=eeb0e4f8&scoped=true"
import script from "./PartnerManage.vue?vue&type=script&lang=js"
export * from "./PartnerManage.vue?vue&type=script&lang=js"

import "./PartnerManage.vue?vue&type=style&index=0&id=eeb0e4f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb0e4f8"]])

export default __exports__